module.exports = __webpack_public_path__ + "img/carrito.f26d2c40.svg";